import { render, staticRenderFns } from "./CustomerSupport.vue?vue&type=template&id=2d0b5576&scoped=true"
import script from "./CustomerSupport.vue?vue&type=script&lang=js"
export * from "./CustomerSupport.vue?vue&type=script&lang=js"
import style0 from "./CustomerSupport.vue?vue&type=style&index=0&id=2d0b5576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b5576",
  null
  
)

export default component.exports